/* @flow */

import React from "react";
import cn from "classnames";
import { useTranslate } from "@awardit/react-use-translate";
import MainLogo from "icons/logo-large.svg";

import styles from "./styles.scss";

type Props = {
  className?: string,
};

const Logo = ({ className }: Props): React$Node => {
  const t = useTranslate();

  return (
    <div className={cn(styles.logoMain, className)}>
      <MainLogo
        alt={t("LOGO.ALT")}
        aria-label={t("LOGO.TITLE")}
      />
    </div>
  );
};

export default Logo;
